import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { AlertTriangle, CheckCircle, Clock, Timer } from "lucide-react";
import { useIncidentDashboard } from "../../hooks";

export const SummaryCards: React.FC = () => {
  const { data: dashboardData } = useIncidentDashboard();
  const metrics = [
    {
      title: "New Incidents",
      count: dashboardData?.newIncidents ?? "NA",
      trendSummary: "Reported in the last 24 hours",
      icon: <AlertTriangle className="h-8 w-8 text-yellow-500" />,
      tooltip: "Total number of incidents reported.",
    },
    {
      title: "High Priority",
      count: dashboardData?.highPriority ?? "NA",
      trendSummary: "Active incidents marked as High",
      icon: <Clock className="h-8 w-8 text-red-500" />,
      tooltip:
        "Count of active incidents marked as *High and Critical*. High priority means service-affecting issues requiring immediate action.",
    },
    {
      title: "Unassigned",
      count: dashboardData?.unassigned ?? "NA",
      trendSummary: "Incidents awaiting assignment",
      icon: <Timer className="h-8 w-8 text-orange-500" />,
      tooltip:
        "Number of incidents that have been logged but not yet assigned to a technician or team.",
    },
    {
      title: "Avg. Time to Resolution",
      count: dashboardData?.avgResolutionTime ?? "NA",
      trendSummary: "Average over the last 30 days",
      icon: <CheckCircle className="h-8 w-8 text-green-500" />,
      tooltip:
        "Average time taken to resolve incidents. Includes all statuses that reached *Resolved*. SLA performance can be monitored from this metric.",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
      {metrics.map((card, index) => (
        <QuickStatsCard
          key={index}
          title={card.title}
          count={card.count}
          trendSummary={card.trendSummary}
          icon={card.icon}
          tooltip={card.tooltip}
        />
      ))}
    </div>
  );
};
